import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication/authentication.service';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()
export class IsLoggedService {

  private itemSource: BehaviorSubject<boolean>;
  public islogged$: Observable<boolean>;
  public isLoggedIn: boolean;

  constructor() {
    this.isLoggedIn = false;
    this.itemSource = new BehaviorSubject(this.isLoggedIn);
    this.islogged$ = this.itemSource.asObservable();
  }

  public changeState(isLogged: boolean) {
    this.isLoggedIn = isLogged;
    this.itemSource.next(isLogged);
  }
}
